import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "content", "$blocks"];
import { createVNode as h, Component } from 'intact-vue-next';
import { Tooltip as BaseTooltip } from './tooltip';
import { TooltipContent } from './content';
import { noop } from 'intact-shared';
function Wrapper(props) {
  var children = props.children,
    content = props.content,
    $blocks = props.$blocks,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if ($blocks && $blocks.content) {
    content = $blocks.content(noop);
  }
  var contentVNode = h(TooltipContent, {
    children: content
  });
  return h(BaseTooltip, _extends({
    children: [children, contentVNode]
  }, rest));
}
var functionalWrapper = Component.functionalWrapper;
export var Tooltip = functionalWrapper ? functionalWrapper(Wrapper) : Wrapper;